/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Areyousure2Inputs */

const en_areyousure2 = /** @type {(inputs: Areyousure2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure?`)
};

const de_areyousure2 = /** @type {(inputs: Areyousure2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bist du sicher?`)
};

/**
* | output |
* | --- |
* | "Are you sure?" |
*
* @param {Areyousure2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const areyousure2 = /** @type {((inputs?: Areyousure2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Areyousure2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_areyousure2(inputs)
	return de_areyousure2(inputs)
});
export { areyousure2 as "areYouSure" }